module.exports = __webpack_public_path__ + "72b2ef957d84b682f383480cf247677b.png";